import type {
  Step,
  Summary,
} from '@/components/DesignSystem/Subsections/CareerPathwayPlanner/types';
import type {
  Degree,
  Subject,
  Occupation,
} from '@/components/DesignSystem/Subsections/SalaryCalculator/types';
import buildSiteUrl from '@/utils/buildSiteUrl';

export interface CareerPathwayPayload {
  currentEducation: Degree;
  fieldOfStudy: Subject;
  currentRole: Occupation;
  targetRole: Occupation;
}

export interface CareerPathwayResponse {
  steps: Step[];
  summary: Summary;
}

export const getCareerPathwayData = async (
  payload: CareerPathwayPayload,
): Promise<CareerPathwayResponse> => {
  const response = await fetch(buildSiteUrl('/api/v1/career-pathway'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      currentEducation: payload.currentEducation.name,
      fieldOfStudy: payload.fieldOfStudy.name,
      currentRole: payload.currentRole.title,
      targetRole: payload.targetRole.title,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return {
    steps: data.steps,
    summary: data.summary,
  };
};
